import { RootState } from 'editor/src/store/index';

const getGalleryImages = (state: RootState) => state.gallery.images;

export default getGalleryImages;
